import React from 'react';
import { Input, Button, Tooltip, Dropdown, Checkbox, Space, Typography, Tag } from 'antd';
import {
  SearchOutlined,
  PrinterOutlined,
  FileExcelOutlined,
  ReloadOutlined,
  SettingOutlined,
  ColumnHeightOutlined,
  PlusOutlined,
} from '@ant-design/icons';

const { Text } = Typography;

const DENSITY_ITEMS = [
  { key: 'small',  label: 'Kichik'    },
  { key: 'middle', label: "O'rtacha"  },
  { key: 'large',  label: 'Katta'     },
];

const TableToolbar = ({
  title,
  searchable,
  searchText,
  onSearch,
  columns,
  visibleColumns,
  onToggleColumn,
  tableSize,
  onSizeChange,
  printable,
  exportable,
  onRefresh,
  onPrint,
  onExport,
  selectedCount,
  loading,
  onAdd,
}) => {
  const togglableCols = columns.filter((col) => col.dataIndex || col.key);

  const columnOverlay = (
    <div
      style={{
        background: 'var(--qk-card-bg)',
        borderRadius: 8,
        boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
        minWidth: 190,
        padding: '8px 0',
      }}
    >
      <div
        style={{
          padding: '4px 14px 8px',
          borderBottom: '1px solid var(--qk-border)',
          marginBottom: 4,
        }}
      >
        <Text type="secondary" style={{ fontSize: 12 }}>
          Ustunlarni ko&apos;rsatish / yashirish
        </Text>
      </div>
      {togglableCols.map((col) => {
        const key = String(col.key || col.dataIndex);
        const label = typeof col.title === 'string' ? col.title : key;
        return (
          <div
            key={key}
            style={{ padding: '6px 14px', cursor: 'pointer' }}
            onClick={() => onToggleColumn(key)}
          >
            <Checkbox
              checked={visibleColumns[key] !== false}
              onChange={() => onToggleColumn(key)}
              onClick={(e) => e.stopPropagation()}
            >
              {label}
            </Checkbox>
          </div>
        );
      })}
    </div>
  );

  const densityItems = DENSITY_ITEMS.map((d) => ({
    key: d.key,
    label: (
      <span style={{ fontWeight: tableSize === d.key ? 600 : 400 }}>{d.label}</span>
    ),
    onClick: () => onSizeChange(d.key),
  }));

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingBottom: 14,
        flexWrap: 'wrap',
        gap: 10,
      }}
    >
      {/* Left */}
      <Space size={10} align="center">
        {title && (
          <Text strong style={{ fontSize: 16 }}>
            {title}
          </Text>
        )}
        {selectedCount > 0 && (
          <Tag color="blue" style={{ margin: 0 }}>
            {selectedCount} ta tanlangan
          </Tag>
        )}
      </Space>

      {/* Right tools */}
      <Space size={6} wrap>
        {onAdd && (
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={onAdd}
          >
            Qo&apos;shish
          </Button>
        )}

        {searchable && (
          <Input
            prefix={<SearchOutlined style={{ color: '#bbb' }} />}
            placeholder="Qidirish..."
            value={searchText}
            onChange={(e) => onSearch(e.target.value)}
            allowClear
            style={{ width: 220 }}
          />
        )}

        <Tooltip title="Jadval zichligi">
          <Dropdown
            menu={{ items: densityItems, selectedKeys: [tableSize] }}
            trigger={['click']}
            placement="bottomRight"
          >
            <Button icon={<ColumnHeightOutlined />} />
          </Dropdown>
        </Tooltip>

        <Tooltip title="Ustunlarni boshqarish">
          <Dropdown
            popupRender={() => columnOverlay}
            trigger={['click']}
            placement="bottomRight"
          >
            <Button icon={<SettingOutlined />} />
          </Dropdown>
        </Tooltip>

        {printable && (
          <Tooltip title="Chop etish">
            <Button icon={<PrinterOutlined />} onClick={onPrint} />
          </Tooltip>
        )}

        {exportable && (
          <Tooltip title="Excel ga eksport">
            <Button
              icon={<FileExcelOutlined />}
              onClick={onExport}
              style={{ color: '#22c55e', borderColor: '#86efac' }}
            />
          </Tooltip>
        )}

        {onRefresh && (
          <Tooltip title="Yangilash">
            <Button
              icon={<ReloadOutlined />}
              onClick={onRefresh}
              loading={loading}
            />
          </Tooltip>
        )}
      </Space>
    </div>
  );
};

export default TableToolbar;
